import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ARPRiskEditor = ({ idSelector, onChange, label }: Props) => {

    const employeeContract = useDataBean(_EmployeeContract)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState<number>(null);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(e);
        onChange(id);
    }

    const getLista = () => {

        employeeContract.instance.getARPRiskCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Categoria de Riesgo"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDARPRisk} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.ArpValue}</option>
                        )
                    })
                }
            </select>
        </>
    )
}